import { Button } from '@travelnest/merlin.button';
import theme from '@travelnest/merlin.theme';
import * as React from 'react';
import { CalendarSyncExportWizard } from './calendar-sync-export/CalendarSyncExportWizard';
import { CalendarSyncImportWizard } from './calendar-sync-import/CalendarSyncImportWizard';

export interface ICalendarSyncLauncherProps {
	propertyId: number | string;
	type: 'import' | 'export';
}

export const CalendarSyncLauncher: React.FC<ICalendarSyncLauncherProps> = ({ propertyId, type }) => {
	const [showModal, setShowModal] = React.useState(false);
	const label = type === 'import' ? 'Import Calendar' : 'Export Calendar';

	if (showModal) {
		if (type === 'import') {
			return <CalendarSyncImportWizard
				propertyId={propertyId}
				onRequestClose={() => setShowModal(false)}
			/>;
		} else {
			return <CalendarSyncExportWizard
				propertyId={propertyId}
				onRequestClose={() => setShowModal(false)}
			/>;
		}
	}

	return <Button
			onClick={() => {
				setShowModal(true);
			}}
			bgColor={theme.colours.background.default}
			label={label}
			>
				<span>{label}</span>
		</Button>;
};
